import axios from 'axios';
import config from 'config';

export default {
    checkIsAdminConnected: (sessionId) => {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: `${config.url}/api/Session/IsAdminConnected?sessionId=${sessionId}`,
                })
                .then((response) => {
                    //handle success
                    resolve(response.data);
                })
                .catch((response) => {
                    //handle error
                    console.log("error", response);
                    reject();
                });
        });
    }
}
